import type { Tone } from "@/components/patterns/StatusPill";

/** Buying roles a contact can hold on a deal */
export const ROLE_LABEL: Record<string, string> = {
  DECISION_MAKER: "Decision maker",
  ECONOMIC_BUYER: "Economic buyer",
  CHAMPION: "Champion",
  INFLUENCER: "Influencer",
  TECHNICAL: "Technical",
  USER: "User",
  BLOCKER: "Blocker",
};

export const ROLE_TONE: Record<string, Tone> = {
  DECISION_MAKER: "gold",
  ECONOMIC_BUYER: "gold",
  CHAMPION: "success",
  INFLUENCER: "primary",
  TECHNICAL: "info",
  USER: "neutral",
  BLOCKER: "danger",
};
